/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023-2024 (original work) Open Assessment Technologies SA ;
 */
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';
import { FEATURE_CANDIDATES } from '@/constants/features';
import { getFeaturesGuard } from '@/core/guards/featureFlagGuard';
import config from '@/config';

export const routing = [
    {
        path: [config.routes.users.list],
        guard: getPermissionsGuard([
            { resource: 'portal.user', scopes: ['view'] },
            { resource: 'portal.user.working-profiles', scopes: ['all'] },
            { resource: 'portal.candidate', scopes: ['view'] }
        ]),
        controller: () => import('@/modules/users/controllers/users')
    },
    {
        path: [config.routes.users.candidateSearch],
        guard: getFeaturesGuard(FEATURE_CANDIDATES),
        controller: () => import('@/modules/users/controllers/candidateSearch')
    },
    {
        path: [config.routes.users.selectGroupsForExisting],
        guard: getPermissionsGuard([
            { resource: 'portal.user', scopes: ['create'] },
            { resource: 'portal.user', scopes: ['edit'] }
        ]),
        controller: () => import('@/modules/users/controllers/userGroups')
    },
    {
        path: [config.routes.users.selectGroupsByHierarchy],
        guard: getPermissionsGuard([
            { resource: 'portal.user', scopes: ['create'] },
            { resource: 'portal.user', scopes: ['edit'] }
        ]),
        controller: () => import('@/modules/users/controllers/userGroups')
    },
    {
        path: [config.routes.users.selectGroups],
        guard: getPermissionsGuard([
            { resource: 'portal.user', scopes: ['create'] },
            { resource: 'portal.user', scopes: ['edit'] }
        ]),
        controller: () => import('@/modules/users/controllers/userGroups')
    },
    {
        path: [config.routes.users.userIntegration],
        guard: getPermissionsGuard([{ resource: 'portal.user-integration', scopes: ['create'] }]),
        controller: () => import('@/modules/users/controllers/userIntegration')
    },
    {
        path: [config.routes.users.user],
        guard: getPermissionsGuard([
            { resource: 'portal.user', scopes: ['create'] },
            { resource: 'portal.user', scopes: ['edit'] },
            { resource: 'portal.user.working-profiles', scopes: ['all'] }
        ]),
        controller: () => import('@/modules/users/controllers/user')
    },
    {
        path: [config.routes.users.editWorkingProfiles],
        guard: getPermissionsGuard([
            { resource: 'portal.user.working-profiles', scopes: ['view'] },
            { resource: 'portal.user.working-profiles', scopes: ['edit'] }
        ]),
        controller: () => import('@/modules/users/controllers/editWorkingProfiles')
    },
    {
        path: [config.routes.users.mergeUsers],
        guard: getPermissionsGuard([{ resource: 'portal.user', scopes: ['merge'] }]),
        controller: () => import('@/modules/users/controllers/mergeUsers')
    }
];
